import * as React from "react";
const reducer = (state, action) => {
  switch (action.type) {
    case "loading":
      return [null, true, null];
    case "loaded":
      return [action.result, false, null];
    case "error":
      return [null, false, action.error];
  }
};
function useDynamicModule(loader, name, deps) {
  const [state, dispatch] = React.useReducer(reducer, [null, true, null]);
  React.useEffect(() => {
    let current = true;
    dispatch({ type: "loading" });
    loader().then((mod) => {
      if (current) {
        dispatch({ type: "loaded", result: mod });
      }
    }).catch((error) => {
      if (current) {
        console.error(`Failed to load dynamic module: ${name}`, error);
        dispatch({ type: "error", error });
      }
    });
    return function detach() {
      current = false;
    };
  }, [name, ...deps]);
  return state;
}
export {
  useDynamicModule
};
//# sourceMappingURL=use-dynamic-module.js.map
